import { useState } from "react";
import { X, Users, GraduationCap, Send, Check, Link2, UserPlus, Copy, Lock, Globe, School } from "lucide-react";
import { useToast } from "../../hooks/use-toast";





const universities = ["ADA University", "Baku State University", "Baku Engineering University", "Khazar University", "ASOIU"];
const years = ["2024", "2025", "2026", "2027", "2028"];
const grades = ["1st Grade", "2nd Grade", "3rd Grade", "4th Grade", "5th Grade", "6th Grade", "7th Grade", "8th Grade", "9th Grade", "10th Grade", "11th Grade"];

const CreateClassModal = ({ onClose }) => {
  const [step, setStep] = useState("create");
  const [name, setName] = useState("");
  const [institutionType, setInstitutionType] = useState("university");
  const [institutionName, setInstitutionName] = useState("");
  const [customInstitution, setCustomInstitution] = useState("");
  const [year, setYear] = useState("2025");
  const [grade, setGrade] = useState("1st Grade");
  const [isPrivate, setIsPrivate] = useState(false);
  const [inviteUsernames, setInviteUsernames] = useState("");
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [inviteLink] = useState(`https://yeniders.app/join/class/${Math.random().toString(36).slice(2, 8)}`);
  const [linkCopied, setLinkCopied] = useState(false);
  const { toast } = useToast();

  const handleAddUsername = () => {
    const usernames = inviteUsernames.split(",").map((u) => u.trim()).filter((u) => u.length > 0 && !invitedUsers.includes(u));
    if (usernames.length > 0) {
      setInvitedUsers((prev) => [...prev, ...usernames]);
      setInviteUsernames("");
    }
  };

  const handleRemoveUser = (username) => {
    setInvitedUsers((prev) => prev.filter((u) => u !== username));
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(inviteLink);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };

  const handleCreate = () => {
    if (!name.trim()) return;
    const inst = institutionName || customInstitution;
    if (!inst.trim()) return;
    setStep("success");
  };

  const institution = institutionName || customInstitution;
  const canCreate = name.trim() && (institutionName || customInstitution.trim());

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" />
      <div className="relative bg-card rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fade-in max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-border sticky top-0 bg-card z-10">
          <h3 className="font-display font-bold text-foreground flex items-center gap-2">
            <Users className="w-4 h-4 text-secondary" />
            {step === "create" ? "Create Class" : "Class Created!"}
          </h3>
          <button onClick={onClose} className="w-8 h-8 rounded-xl hover:bg-muted flex items-center justify-center transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>

        {step === "create" ?
        <div className="p-5 space-y-4">
            {/* Class Name */}
            <div>
              <label className="text-xs font-medium text-foreground mb-1.5 block">Class Name *</label>
              <input value={name} onChange={(e) => setName(e.target.value)}
            placeholder="e.g. CS201 — Data Structures"
            className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
            
            </div>

            {/* Institution Type Toggle */}
            <div>
              <label className="text-xs font-medium text-foreground mb-1.5 block">Institution Type</label>
              <div className="flex gap-1 p-1 rounded-xl bg-muted w-fit">
                <button onClick={() => setInstitutionType("university")}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
              institutionType === "university" ? "bg-card text-foreground shadow-sm" : "text-muted-foreground"}`
              }>
                  <GraduationCap className="w-3.5 h-3.5" /> University
                </button>
                <button onClick={() => setInstitutionType("school")}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
              institutionType === "school" ? "bg-card text-foreground shadow-sm" : "text-muted-foreground"}`
              }>
                  <School className="w-3.5 h-3.5" /> School
                </button>
              </div>
            </div>

            {/* Institution Name */}
            <div>
              <label className="text-xs font-medium text-foreground mb-1.5 block">
                {institutionType === "university" ? "University Name *" : "School Name *"}
              </label>
              {institutionType === "university" ?
            <div className="space-y-2">
                  <select value={institutionName} onChange={(e) => {setInstitutionName(e.target.value);setCustomInstitution("");}}
              className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring">
                    <option value="">Select university...</option>
                    {universities.map((u) => <option key={u} value={u}>{u}</option>)}
                    <option value="__custom">Other (type manually)</option>
                  </select>
                  {institutionName === "__custom" &&
              <input value={customInstitution} onChange={(e) => setCustomInstitution(e.target.value)}
              placeholder="Enter university name"
              className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />

              }
                </div> :

            <input value={customInstitution} onChange={(e) => {setCustomInstitution(e.target.value);setInstitutionName("");}}
            placeholder="Enter school name"
            className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />

            }
            </div>

            {/* Year / Grade */}
            <div>
              <label className="text-xs font-medium text-foreground mb-1.5 block">
                {institutionType === "university" ? "Year Started *" : "Starting Grade *"}
              </label>
              {institutionType === "university" ?
            <select value={year} onChange={(e) => setYear(e.target.value)}
            className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring">
                  {years.map((y) => <option key={y} value={y}>{y}</option>)}
                </select> :

            <select value={grade} onChange={(e) => setGrade(e.target.value)}
            className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring">
                  {grades.map((g) => <option key={g} value={g}>{g}</option>)}
                </select>
            }
            </div>

            {/* Privacy */}
            <div>
              <label className="text-xs font-medium text-foreground mb-1.5 block">Privacy</label>
              <div className="flex gap-2">
                <button onClick={() => setIsPrivate(false)}
              className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2.5 rounded-xl text-xs font-medium transition-colors ${
              !isPrivate ? "bg-secondary/15 text-secondary ring-1 ring-secondary/30" : "bg-muted text-muted-foreground"}`
              }>
                  <Globe className="w-3.5 h-3.5" /> Public
                </button>
                <button onClick={() => setIsPrivate(true)}
              className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2.5 rounded-xl text-xs font-medium transition-colors ${
              isPrivate ? "bg-secondary/15 text-secondary ring-1 ring-secondary/30" : "bg-muted text-muted-foreground"}`
              }>
                  <Lock className="w-3.5 h-3.5" /> Private
                </button>
              </div>
              <p className="text-[10px] text-muted-foreground mt-1">
                {isPrivate ? "Members need admin approval to join." : "Anyone can join this class freely."}
              </p>
            </div>

            {/* Invite Members */}
            <div>
              <label className="text-xs font-medium text-foreground mb-1.5 block">Invite Members (optional)</label>
              <div className="flex gap-2">
                <div className="relative flex-1">
                  <UserPlus className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                  <input value={inviteUsernames} onChange={(e) => setInviteUsernames(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAddUsername()}
                placeholder="Enter usernames, separated by commas"
                className="w-full pl-10 pr-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
                
                </div>
                <button onClick={handleAddUsername}
              className="px-3 py-2.5 rounded-xl bg-secondary/10 text-secondary text-xs font-semibold hover:bg-secondary/20 transition-colors">
                  Add
                </button>
              </div>
              {invitedUsers.length > 0 &&
            <div className="flex flex-wrap gap-1.5 mt-2">
                  {invitedUsers.map((user) =>
              <span key={user} className="flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-primary/10 text-primary font-medium">
                      @{user}
                      <button onClick={() => handleRemoveUser(user)}><X className="w-3 h-3" /></button>
                    </span>
              )}
                </div>
            }
            </div>

            {/* Invite Link */}
            <div>
              <label className="text-xs font-medium text-foreground mb-1.5 block">Or share invite link</label>
              <div className="flex items-center gap-2 p-2.5 rounded-xl bg-muted">
                <Link2 className="w-4 h-4 text-muted-foreground flex-shrink-0" />
                <span className="text-xs text-muted-foreground truncate flex-1">{inviteLink}</span>
                <button onClick={handleCopyLink}
              className={`px-2.5 py-1 rounded-lg text-xs font-semibold transition-colors flex items-center gap-1 ${
              linkCopied ? "bg-secondary text-secondary-foreground" : "bg-primary/10 text-primary hover:bg-primary/20"}`
              }>
                  {linkCopied ? <><Check className="w-3 h-3" /> Copied</> : <><Copy className="w-3 h-3" /> Copy</>}
                </button>
              </div>
            </div>

            <button onClick={handleCreate} disabled={!canCreate}
          className="w-full h-10 rounded-2xl bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-40 flex items-center justify-center gap-1.5">
              <Send className="w-4 h-4" /> Create Class
            </button>
          </div> :

        <div className="p-5 text-center space-y-4">
            <div className="w-16 h-16 rounded-2xl bg-secondary/15 flex items-center justify-center mx-auto">
              <Check className="w-8 h-8 text-secondary" />
            </div>
            <div>
              <p className="text-lg font-display font-bold text-foreground">{name}</p>
              <p className="text-sm text-muted-foreground mt-1">
                {institution} · {institutionType === "university" ? year : grade}
                {isPrivate ? " · Private" : " · Public"}
              </p>
              <p className="text-xs text-muted-foreground mt-2">Your class has been created successfully!</p>
              {invitedUsers.length > 0 &&
            <p className="text-xs text-secondary mt-1">Invitations sent to {invitedUsers.length} user{invitedUsers.length > 1 ? "s" : ""}.</p>
            }
            </div>
            <div className="space-y-2">
              <button onClick={handleCopyLink}
            className="w-full h-10 rounded-2xl bg-secondary text-secondary-foreground text-sm font-semibold hover:bg-secondary/90 transition-colors flex items-center justify-center gap-1.5">
                <Link2 className="w-4 h-4" /> {linkCopied ? "Link Copied!" : "Copy Invite Link"}
              </button>
              <button onClick={onClose} className="w-full h-9 text-sm text-muted-foreground hover:text-foreground transition-colors">
                Done
              </button>
            </div>
          </div>
        }
      </div>
    </div>);

};

export default CreateClassModal;